<template>
  <div class="bb-bank">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-bank-header">
      <h2 class="bb-page-title bb-bank-header__title">Bank Details</h2>
      <button class="bb-button bb-bank-header__btn" @click="showBankForm = true">ADD</button>
    </div>
    <transition name="routing-fade">
      <bank-details-form :bank-details="newBankDetails" v-if="showBankForm" :loader="loaderRun"
                         @cancel="showBankForm = false, clearInput()" @save="createBankDetails"/>
    </transition>
    <div class="bb-bank-details">
      <transition-group name="fade-form">
        <div v-for="(item, index) in bankDetails"
           :key="item.id" :class="{'bb-bank-details-item_editable' : editFormIndex === index}">
        <transition name="routing-fade">
          <bank-details-form :bank-details="item" :editable="editFormIndex" v-if="editFormIndex === index"
                             :loader="loaderRun" @cancel="editFormIndex = false" @save="editBankDetails"/>
        </transition>
        <div v-if="editFormIndex !== index" class="bb-bank-details-item" v-click-outside="toolbarHide">
          <i class="icon-menu bb-bank-details-item__menu"
             @click.stop="toolbarOpen(index)"/>
          <transition name="routing-fade">
            <div class="bb-bank-details-item__toolbar" v-if="toolbarIndex === index" @click.stop>
            <Toolbar :delete-index="deleteConfirm"
                     :index="index"
                     :item="item"
                     @deleteOpen="deleteConfirm = index"
                     @deleteClose=" deleteConfirm = false"
                     @openEdit="editFormIndex = index"
                     @deleteItem="deleteBankDetails"/>
            </div>
          </transition>
          <div class="bb-bank-details-item__name">{{item.name}}</div>
          <div class="bb-bank-details-item__details"><pre>{{item.details}}</pre></div>
          <div class="bb-bank-details-item-iban">
            <div class="bb-bank-details-item-iban__number">
              <span class="bb-bank-details-item-iban__title">AED:</span>
              {{item.iban.aed}}
            </div>
            <div class="bb-bank-details-item-iban-rate">
              <div class="bb-bank-details-item-iban__number">
                <span class="bb-bank-details-item-iban__title">USD:</span>
                {{item.iban.usd}}
              </div>
              <span class="bb-bank-details-item-iban-rate__number bb-bank-details-item-iban__title">
                {{item.currencyRates ? item.currencyRates.usd : ''}}
              </span>
            </div>
            <div class="bb-bank-details-item-iban-rate">
              <div class="bb-bank-details-item-iban__number">
                <span class="bb-bank-details-item-iban__title">EUR:</span>
                {{item.iban.eur}}
              </div>
              <span class="bb-bank-details-item-iban-rate__number bb-bank-details-item-iban__title">
                {{item.currencyRates ? item.currencyRates.eur : ''}}
              </span>
            </div>
            <div class="bb-bank-details-item-iban-rate">
              <div class="bb-bank-details-item-iban__number">
                <span class="bb-bank-details-item-iban__title">RUB:</span>
                {{item.iban.rub}}
              </div>
              <span class="bb-bank-details-item-iban-rate__number bb-bank-details-item-iban__title">
                {{item.currencyRates ? item.currencyRates.rub : ''}}
              </span>
            </div>
          </div>
        </div>
      </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import bankDetailsApi from '@/api/BankDetails/api'
import BankDetailsForm from '@/components/Settings/Forms/BankDetailsForm'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'

export default {
  name: 'SettingsUsers',
  components: {
    BankDetailsForm,
    Toolbar,
    LoaderFly
  },
  data () {
    return {
      loaderRun: false,
      showBankForm: false,
      toolbarIndex: false,
      deleteConfirm: false,
      editFormIndex: false,
      newBankDetails: {
        name: '',
        details: '',
        iban: {
          aed: '',
          usd: '',
          eur: '',
          rub: '',
        }
      }
    }
  },
  computed: {
    bankDetails: {
      get: function () {
        return this.$store.getters.bankDetails
      },
      set: function (data) {
        this.$store.dispatch('setBankDetails', data)
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    }
  },
  methods: {
    toolbarOpen (index) {
      this.toolbarIndex = index
      this.deleteConfirm = false
    },
    toolbarHide () {
      this.toolbarIndex = false
      this.deleteConfirm = false
    },
    clearInput () {
      this.newBankDetails.id = '';
      this.newBankDetails.name = '';
      this.newBankDetails.details = '';
      this.newBankDetails.iban.aed = '';
      this.newBankDetails.iban.usd = '';
      this.newBankDetails.iban.eur = '';
      this.newBankDetails.iban.rub = '';
    },
    getBankDetails () {
      this.loaderRun = true
      bankDetailsApi.getBankDetails({bankDetails: this.newBankDetails})
        .then((resp) => {
          this.bankDetails = resp.data.bankDetails
          this.clearInput()
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    createBankDetails (item) {
      this.loaderRun = true
      bankDetailsApi.addBankDetails({bankDetails: item})
        .then((resp) => {
          this.clearInput()
          this.loaderRun = false
          this.showBankForm = false
          this.bankDetails.unshift(resp.data)
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    editBankDetails (item, index) {
      this.loaderRun = true
      bankDetailsApi.editBankDetails({bankDetails: item}, item.id)
        .then((resp) => {
          this.bankDetails.splice(index, 1, resp.data)
          this.editFormIndex = false
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    deleteBankDetails (index, id) {
      this.bankDetails.splice(index, 1)
      bankDetailsApi.delBankDetails(id)
        .then((resp) => {
          this.toolbarIndex = false
          this.deleteConfirm = false
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  watch: {
    activeCompany: function () {
      this.getBankDetails()
    }
  },
  beforeMount () {
    this.getBankDetails()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../sass/variables";
  @import "../../sass/mixins";

  .bb-bank {
    @include global-font;

    &-header {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      max-width: 468px;

      &__btn {
        width: 73px;
        height: 42px;
      }
    }

    &-details {
      display: flex;
      flex-direction: column;
      margin-top: 46px;

      &-item {
        position: relative;
        max-width: 468px;
        background: $color-white;
        box-shadow: 0 0 25px rgba($color-black, 0.05);
        border-radius: 5px;
        margin-bottom: 20px;
        padding: 26px 36px;

        &_editable {
          background: none;
          box-shadow: none;
          padding: 0;
          margin-bottom: 20px;
        }

        &__menu {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 26px;
          height: 25px;
          top: 8px;
          right: 7px;
          font-size: 10px;
          color: $color-accent;
          cursor: pointer;
          user-select: none;
          transition: .15s;

          &:hover {
            opacity: 0.8;
          }
        }

        &__name {
          margin-bottom: 15px;
          color: $color-accent;
          font-weight: 600;
          font-size: 14px;
          line-height: 17px;
        }

        &__details {
          margin-bottom: 17px;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;

          pre {
            white-space: pre-line;
          }
        }

        &-iban {
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;

          &__number {
            margin-top: 16px;
          }

          &__title {
            margin-right: 18px;
            font-weight: 600;
            color: $color-accent
          }

          &-rate {
            display: grid;
            grid-template-columns: 1fr 75px;
            grid-gap: 25px;

            &__number {
              justify-self: flex-end;
              margin-right: 0;
              margin-top: 16px;
            }
          }
        }

        &__toolbar {
          position: absolute;
          top: 13px;
          right: 13px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 7px;
          width: 62px;
          height: 36px;
          background: $color-white;
          box-shadow: 0 0 15px rgba($color-black, 0.1);
          border-radius: 4px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/BankDetails.vue